import { createContext } from 'react';

import { FormFieldContextType } from './types';

const FormFieldContext = createContext<FormFieldContextType>(({
  dataKey: undefined,
  label: undefined,
} as unknown) as FormFieldContextType);

export default FormFieldContext;
